/* unplugin-vue-components disabled */import { render } from "./sources-section.vue?vue&type=template&id=659ab582&scoped=true"
import script from "./sources-section.vue?vue&type=script&lang=js"
export * from "./sources-section.vue?vue&type=script&lang=js"

import "./sources-section.vue?vue&type=style&index=0&id=659ab582&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659ab582"],['__file',"src/components/sources-v2/sources-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "659ab582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('659ab582', __exports__)) {
    api.reload('659ab582', __exports__)
  }
  
  module.hot.accept("./sources-section.vue?vue&type=template&id=659ab582&scoped=true", () => {
    api.rerender('659ab582', render)
  })

}


export default __exports__